import React, { useCallback, useEffect, useState } from 'react';
import AssetBreakdownPieChart from '../../../components/Charts/AssetBreakdownPieChart';
import EmptyState from '../../../components/EmptyState';
import { getNumbersWithDecimalPlaces } from '../../../utilities/money';
import { useNavigate } from 'react-router-dom';

const AssetBreakdownTwo = (props) => {
  const { chain_asset_breakdown } = props;
  const navigate = useNavigate();
  const [assets, setAssets] = useState([]);
  const [assetsTwo, setAssetsTwo] = useState([]);

  const handleNavigate = (props) => {
    if (props.individualPage) {
      props.navigatedTab(4);
    } else {
      navigate('/assets');
    }
  };
  const BreakDownAssets = useCallback(() => {
    if (chain_asset_breakdown) {
      let OrganizedAssets = Object.keys(chain_asset_breakdown).map((key) => {
        let value = 0;
        chain_asset_breakdown[key].forEach((asset) => {
          if (asset.total > 0) {
            value += asset.total;
          }
        });
        return { name: key.toUpperCase(), value, key: key };
      });
      let total = 0;
      if (OrganizedAssets.length > 0) {
        total = OrganizedAssets.map(amount).reduce(sum);
      }
      OrganizedAssets.forEach((asset) => {
        asset.name = `${asset.name} ${getNumbersWithDecimalPlaces(
          (asset.value / total) * 100,
          5
        )} %`;
      });
      setAssets(OrganizedAssets);
    }
  }, [chain_asset_breakdown]);

  function amount(item) {
    return item.value;
  }

  function sum(prev, next) {
    return prev + next;
  }

  const BreakDownAssetsTwo = useCallback(() => {
    if (chain_asset_breakdown) {
      let OrganizedAssetsTwo = Object.keys(chain_asset_breakdown).map((key) => {
        let arr = [];
        chain_asset_breakdown[key].forEach((asset) => {
          if (asset.total > 0) {
            arr = [...arr, { name: `${key} ${asset.token}`, value: asset.total, key: key }];
          }
        });
        return arr;
      });
      let outsideToken = [];
      OrganizedAssetsTwo.forEach((asset) => {
        if (outsideToken) {
          outsideToken = [...outsideToken, ...asset];
        }
      });
      setAssetsTwo(outsideToken);
    }
  }, [chain_asset_breakdown]);

  useEffect(() => {
    BreakDownAssets();
    BreakDownAssetsTwo();
  }, [BreakDownAssets, BreakDownAssetsTwo]);

  return (
    <>
      <div className="home_card_two" style={{ height: '405px' }}>
        <div style={{ height: '100%' }}>
          <div style={{ height: '100%' }}>
            <div style={{ marginBottom: '1rem' }}>
              <span className="heading_text">{props.title ? props.title : 'Asset Breakdown'}</span>
            </div>
            {assets && assets.length ? (
              <AssetBreakdownPieChart data01={assets} data02={assetsTwo} />
            ) : (
              <div className="empty_state_charts">
                {' '}
                <EmptyState />{' '}
              </div>
            )}
          </div>
        </div>
        {props.individualPage && (
          <div
            className="view-assets"
            style={{ color: '#006DCC', cursor: 'pointer' }}
            onClick={handleNavigate}
          >
            View All Assets
          </div>
        )}
      </div>
    </>
  );
};

export default AssetBreakdownTwo;
